







import { defineComponent, reactive, toRefs, onMounted } from "@vue/composition-api";
import useWxButton from "@/hooks/useWxButton";
export default defineComponent({
  name: "Home",
  components: {},
  setup() {
    const state = reactive<{
      content: string;
    }>({
      content: "Hello world"
    });
    onMounted(() => {
      useWxButton();
    });
    return {
      ...toRefs(state)
    };
  }
});
